














import { Component, Vue } from "vue-property-decorator";
import AbpBase from "@/lib/abpbase";
import PdPushList from "./pdPush/index.vue";
import PdReceive from "./pdReceive/index.vue";
@Component({
  components: {
    PdPushList,
    PdReceive
  }
})
export default class PdReferral extends AbpBase {
  label1 = (h: any) => {
    return h("div", [
      h("span", "待接收"),
      h("Badge", {
        props: {
          count: 0
        }
      })
    ]);
  };
  label2 = (h: any) => {
    return h("div", [
      h("span", "我推送的"),
      h("Badge", {
        props: {
          count: 0
        }
      })
    ]);
  };

  refreshPushCount(count: any) {
    // this.label2 = (h: any) => {
    //   return h("div", [
    //     h("span", "我推送的"),
    //     h("Badge", {
    //       props: {
    //         count: count
    //       }
    //     })
    //   ]);
    // };
  }

  refreshReceiveCount(count: any) {
    this.label1 = (h: any) => {
      return h("div", [
        h("span", "待接收"),
        h("Badge", {
          props: {
            count: count
          }
        })
      ]);
    };
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/pdReferral/index.vue